// Stato della scadenza di un ticket, condiviso tra la lista ticket e il
// dettaglio - centralizzato qui per non duplicare la stessa soglia (metà del
// tempo trascorso tra apertura e scadenza) in più punti.

// 'overdue' se già scaduto, 'warning' se oltre metà del tempo trascorso tra
// apertura e scadenza (ma non ancora scaduto), 'ok' altrimenti - 'none' se il
// ticket non ha scadenza o è già chiuso/risolto (non ha più senso segnalarlo).
import { parseDbDate } from './kernelFormat';

export function dueDateStatus(ticket) {
  if (!ticket.due_at || ['resolved', 'closed'].includes(ticket.status)) return 'none';
  const due = parseDbDate(ticket.due_at);
  const now = new Date();
  if (due < now) return 'overdue';
  if (!ticket.created_at) return 'ok';
  const created = parseDbDate(ticket.created_at);
  const totalMs = due - created;
  if (totalMs <= 0) return 'warning';
  const elapsedMs = now - created;
  return elapsedMs >= totalMs / 2 ? 'warning' : 'ok';
}

export const DUE_BADGE_CLASS = { overdue: 'badge-danger', warning: 'badge-warning', ok: 'badge-neutral', none: 'badge-neutral' };
